import { CardContent } from '@mui/material';
import { ModelType } from 'api/model';
import LLMIcon from 'components/LLMIcon/LLMIcon';
import { SelectableCard } from 'views/flow/form/SelectableCard';

type Props = {
  provider: ModelType;
  selected?: boolean;
  onClick?: () => void;
};

const ModelProviderCard = ({ provider, selected = false, onClick }: Props) => {
  return (
    <SelectableCard variant="outlined" selected={selected} width="100%" height={110} onClick={onClick}>
      <CardContent className="flex h-full items-center justify-center overflow-hidden px-4 [&_svg]:h-auto [&_svg]:max-w-full">
        <LLMIcon provider={provider} size={24} />
      </CardContent>
    </SelectableCard>
  );
};

export default ModelProviderCard;
